import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='')
  apiUrl = `${protocol}//${hostname}/api`

const getServicesRequested = () => ({
  type: types.GET_SERVICES_REQUESTED,
  payload: null
})

const getServicesRejected = (error: any) => ({
  type: types.GET_SERVICES_REJECTED,
  payload: error
})

const getServicesFulfilled = (data: Array<any>) => ({
  type: types.GET_SERVICES_FULFILLED,
  payload: data
})

export const getServices = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getServicesRequested())
    const apiURL = `${apiUrl}/provider/services/${id}`
    request
      .get(apiURL)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getServicesFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getServicesRejected(error))
      })
  }
}